/* global SWDLocalise */
import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import history from 'instantsearch.js/es/lib/routers/history';
import { configure } from 'instantsearch.js/es/widgets';
import { connectMenu } from 'instantsearch.js/es/connectors';
import customClearRefinements from './widgets/clear-refinements';
import customMenuSelect from './widgets/menu-select';
import customHitsTable from './widgets/hits-table';

const searchForm = document.querySelector('.js-psearch');

const setup = () => {
    const algoliaClient = algoliasearch(
        SWDLocalise.algoliaAppID,
        SWDLocalise.algoliaAPIKey,
    );

    const searchClient = {
        ...algoliaClient,
    };

    const indexName = `${SWDLocalise.algoliaIndex}tyre`;

    const search = instantsearch({
        searchClient,
        indexName,
        routing: {
            router: history({
                createURL({ qsModule, routeState, location }) {
                    const queryParameters = {};

                    // section
                    if (routeState.section) {
                        queryParameters.section = routeState.section;
                    }

                    // profile
                    if (routeState.profile) {
                        queryParameters.profile = routeState.profile;
                    }

                    // rim
                    if (routeState.rim) {
                        queryParameters.rim = routeState.rim;
                    }

                    // load
                    if (routeState.load) {
                        queryParameters.load = routeState.load;
                    }

                    // speed
                    if (routeState.speed) {
                        queryParameters.speed = routeState.speed;
                    }

                    const queryString = qsModule.stringify(queryParameters, {
                        addQueryPrefix: true,
                        arrayFormat: 'repeat',
                    });

                    return `${location.origin + location.pathname + queryString}`;
                },

                parseURL({ qsModule, location }) {
                    const {
                        section = '',
                        profile = '',
                        rim = '',
                        load = '',
                        speed = '',
                    } = qsModule.parse(
                        location.search.slice(1),
                    );

                    return {
                        section,
                        profile,
                        rim,
                        load,
                        speed,
                    };
                },
            }),

            stateMapping: {
                stateToRoute(uiState) {
                    const indexUiState = uiState.wp_tyre || {};

                    return {
                        section: indexUiState.menu && indexUiState.menu.section,
                        profile: indexUiState.menu && indexUiState.menu.profile,
                        rim: indexUiState.menu && indexUiState.menu.rim,
                        load: indexUiState.menu && indexUiState.menu.load,
                        speed: indexUiState.menu && indexUiState.menu.speed,
                    };
                },

                routeToState(routeState) {
                    return {
                        wp_tyre: {
                            menu: {
                                section: routeState.section,
                                profile: routeState.profile,
                                rim: routeState.rim,
                                load: routeState.load,
                                speed: routeState.speed,
                            },
                        },
                    };
                },
            },
        },
        searchFunction(helper) {
            helper
                .clearRefinements('ID')
                .addFacetRefinement('ID', searchForm.dataset.id);

            helper.search();
        },
        future: {
            preserveSharedStateOnUnmount: true,
        },
    });

    const virtualMenu = connectMenu(() => null);

    search.addWidgets([
        configure({
            distinct: false,
            facets: ['ID'],
        }),

        virtualMenu({
            attribute: 'ID',
        }),

        customClearRefinements({
            container: document.querySelector('.js-psearch-clear-refinements'),
            excludedAttributes: ['id'],
        }),

        customMenuSelect({
            container: document.querySelector('.js-psearch-filter-section'),
            attribute: 'section',
            limit: 100,
        }),

        customMenuSelect({
            container: document.querySelector('.js-psearch-filter-profile'),
            attribute: 'profile',
            limit: 100,
        }),

        customMenuSelect({
            container: document.querySelector('.js-psearch-filter-rim'),
            attribute: 'rim',
            limit: 100,
        }),

        customMenuSelect({
            container: document.querySelector('.js-psearch-filter-load'),
            attribute: 'load',
            limit: 100,
            sortBy: ['name:desc'],
        }),

        customMenuSelect({
            container: document.querySelector('.js-psearch-filter-speed'),
            attribute: 'speed',
            limit: 100,
        }),

        customHitsTable({
            container: document.querySelector('.js-psearch-results'),
        }),
    ]);

    search.start();
};

const init = () => {
    if (!searchForm) return;
    setup();
};

export default init;
